import React from 'react';
import styled from 'styled-components';

const DivStyled = styled.div`
  color: #9e9e9e;
  & p {
    text-align: center;
    font-size: 10px;
  }
`;

interface Props {
  text: string | JSX.Element | JSX.Element[] | null | undefined;
}

export const PrivacyInformations: React.FunctionComponent<Props> = ({ text }: Props) => {
  return <DivStyled>
    <p>
      {text}
    </p>
  </DivStyled>;
};
